import { render, staticRenderFns } from "./Circlebar.vue?vue&type=template&id=8afc6b7a&scoped=true"
import script from "./Circlebar.vue?vue&type=script&lang=js"
export * from "./Circlebar.vue?vue&type=script&lang=js"
import style0 from "./Circlebar.vue?vue&type=style&index=0&id=8afc6b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afc6b7a",
  null
  
)

export default component.exports